export default interface AnalyticsEvent {
    event_name: string
    event_source: EventSource
}

export enum EventSource {
    APP = 'APP',
    API = 'API'
}
